export function tokenExpiry(req) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req)
    };
    // console.log('POST Quotes', requestOptions)
    return fetch('/shared/api/tokenExpiry', requestOptions).then((response) => response.json())
}